module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxtDawAUxQv-nqIa2sHgh1E4.woff2";